import "./team-person-tile.scss";

import React from "react";

const TeamPersonTile = ({ name, jobName, avatar, email, phone, onClick }) => {
  return (
    <div className="person-tile">
      {avatar && (
        <img src={avatar} alt={name} className="person-tile__avatar" />
      )}
      <div
        className="person-tile__job"
        dangerouslySetInnerHTML={{ __html: jobName }}
      />
      <div className="person-tile__name">{name}</div>
      <a
        href={`mailto:${email}`}
        className="person-tile__contact-link person-tile__contact-link--email"
      >
        {email}
      </a>
      <a
        href={`tel:${phone}`}
        className="person-tile__contact-link person-tile__contact-link--phone"
      >
        {phone}
      </a>
      <a
        href="#formularz"
        onClick={onClick}
        className="person-tile__contact-btn"
      >
        Wyślij wiadomość
      </a>
    </div>
  );
};

export default TeamPersonTile;
